export default __webpack_public_path__ + "static/media/delete.6b8e0310.svg";